import React from 'react';
import { Query } from 'react-apollo';
import { ErrorScreen, Loading } from '../../components/utils';
import logo from '../../images/logo-pink.svg';
import { VERSION_QUERY } from '../../queries/common';

class VersionPage extends React.Component {
  public state = {
    appVersion: ''
  };

  public componentDidMount() {
    this.setState({ appVersion: process.env.DEPLOY_SHA });
  }

  public render() {
    const { appVersion } = this.state;
    return (
      <div className="absolute absolute--fill overflow-auto flex flex-column justify-between items-center pa4">
        <img className="w3" src={logo} alt="" />
        <div className="tc">
          <Query query={VERSION_QUERY}>
            {({ data, error, loading }) => {
              if (loading) {
                return <Loading />;
              }
              if (error) {
                return <ErrorScreen error={error.message} />;
              }
              const { version, commitSha, releasedAt } = data.version;
              return (
                <>
                  <p className="f6 serif">Server Version: {version}</p>
                  <p className="f6 serif">Server Commit: {commitSha}</p>
                  <p className="f6 serif">Server Release Date: {releasedAt}</p>
                </>
              );
            }}
          </Query>
          <p className="f6 serif">Client Version: {appVersion}</p>
        </div>
      </div>
    );
  }
}

export default VersionPage;
